import * as React from "react";
import type { SVGProps } from "react";
const SvgSettingEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.543 16.67v-5.002M4.543 9.167V3.33M10 16.67V10M10 7.5V3.33M15.457 16.67v-3.335M15.457 10.834V3.331M2.497 11.668H6.59M7.955 7.5h4.092M13.412 13.335h4.092"
    />
  </svg>
);
export default SvgSettingEdit;
